var common=require("./common.js");
common.init();
var search={
	init:function(){
		$(".searchBtn").click(function(){
			var txt=$(".searchIpt").val();
			if(!txt.match(/^[0-9]*$/)){
				common.showCommonPop("请输入技能宏ID进行搜索查找");
				return;
			}
			$.getJSON("/skillmacros/getById.json?id="+txt,function(msg){
				if(msg.resCode!=0){
					// common.showCommonPop(msg.resReason);
					common.showCommonPop("缺少该ID的技能宏，请重新查找");
					return;
				}
				window.location.href="/skillmacros/detail?id="+txt;
			})
		})
	}
}
search.init();
module.exports=search;


//////////////////
// WEBPACK FOOTER
// ./pages/skillmacros/js/search.js
// module id = 10
// module chunks = 0 2 3 6